const content = {
  title: "Modal Verbs: Obligation, Necessity & Deduction",
  explanation: `
At B2 level, modal verbs are essential for expressing stance: duty, permission, advice, likelihood, and inference.
Example: You must submit the form today.

They help distinguish strict obligation from recommendation.
Example: You have to wear a badge, but you should arrive early.

Modals also support evidence-based deduction in present and past contexts.
Example: She must be at home. / He can't have forgotten the meeting.

Using the right modal makes communication precise, especially in professional and academic contexts.
Example: The results may indicate a measurement error.
  `,
  rules: [
    "Must / have to express strong obligation or necessity",
    "Mustn't expresses prohibition (something is not allowed)",
    "Should / ought to express advice or weak obligation",
    "May / might / could express possibility or uncertainty",
    "Must / can't express logical deduction based on evidence"
  ],
  examples: [
    "You must wear a helmet at the construction site.",
    "Employees have to follow company regulations.",
    "You mustn't park here. It's prohibited.",
    "She should revise before the exam.",
    "He must be tired after working all night. (logical deduction)",
    "That can't be the right answer. (negative deduction)"
  ]
};

export default content;


